import type { CartDataSource } from '~/api/data-source/cart';
import { cartDataSource } from '~/api/data-source/cart';

export interface CartRepository {
  getCartCount(): Promise<number>;
}

export class CartRepositoryImpl implements CartRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(private readonly dataSource: CartDataSource = cartDataSource) {}

  async getCartCount() {
    return this.dataSource.getCartCount();
  }
}

export const cartRepository = new CartRepositoryImpl();
